import { useSelector } from 'react-redux';
import { LoyaltyContextType, LoyaltyStatus, LoyaltyTier } from '@pegasus/plus';
import { getCookie } from '@pegasus/utils';
import { useConfig } from '@browsing/config';
import { getLoyalty } from '@client/redux/modules/customer';
import { useCustomer } from '@client/hooks';

export const useLoyalty = (): LoyaltyContextType => {
    const config = useConfig();
    const loyalty = useSelector(getLoyalty);
    useCustomer();

    const isEnabled = config.isEnabled('loyalty') || getCookie('zl_loyalty') === 'true';

    const mockTier = getCookie('zl_loyalty_tier') as LoyaltyTier;

    return {
        isEnabled,
        summary: {
            ...loyalty,
            ...(mockTier && { tier: mockTier }),
        },
    };
};
